:host {
  --color-background-interactive: var(--pine-color-background-subtle);

  border-color: inherit;
  display: table-row;
  vertical-align: inherit;

  // used for pds-checkbox-cell
  // because it is in the ShadowDom
  &::part(checkbox-cell) {
    background-color: var(--pine-color-background-container);
    inset-inline-start: var(--pine-dimension-none);
    position: sticky;
    z-index: var(--pine-z-index-raised);
  }
}

:host(:hover),
:host(:hover)::part(checkbox-cell),
:host(:hover) ::slotted(pds-table-cell),
:host(.is-selected),
:host(.is-selected)::part(checkbox-cell),
:host(.is-selected) ::slotted(pds-table-cell) {
  background: var(--color-background-interactive);
}

:host(.has-divider) ::slotted(pds-table-cell),
:host(.has-divider) pds-table-cell {
  border-block-end: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
}

:host(.has-divider.is-last-row) ::slotted(pds-table-cell),
:host(.has-divider.is-last-row) pds-table-cell {
  border-block-end: 0;
}
